import clipboardCopy from "clipboard-copy";
import { debounce } from "lodash";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

type UseCopyToClipboardReturnType = [
  boolean, // isCopied
  (text: string) => void, // copyToClipboard function
];

const useCopyToClipboard = (): UseCopyToClipboardReturnType => {
  const [isCopied, setCopied] = useState<boolean>(false);

  const copyToClipboard = useCallback(async (text: string) => {
    const resetIsCopied = debounce(() => {
      setCopied(false);
    }, 1000);
    try {
      await clipboardCopy(text).then(() => {
        setCopied(true);
        toast.success("Copied ✨", {
          position: "bottom-left",
        });
        resetIsCopied();
      });
    } catch (error) {
      toast.error("Error while copying text.", {
        position: "bottom-left",
      });
      setCopied(false);
    }
  }, []);

  return [isCopied, copyToClipboard];
};

export default useCopyToClipboard;
